import { Utils } from 'common';

const { Communication } = Utils;

export default class MailCommunication extends Communication {
	static init(params) {
		Communication.init(params);
	}
}
